'use client'
import React, { useState } from 'react'
import Link from 'next/link'
import TabNavigation from './onboardingTabs'
import VerifyEmail from './verifyEmail'
import SetPassword from './setPassword'
import BusinessDetails from './businessDetails'
import BasicInformation from './basicInfo'
import FormBackgroundLayout from '../components/form-background-layout'
import './onboarding.css'

const Onboarding: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [areFieldsSet, setAreFieldsSet] = useState(false)
  const [step, setStep] = useState(1)
  const [isVerified, setIsVerified] = useState(false)

  const handleVerify = (isVerified: boolean) => {
    setIsVerified(isVerified)
  }

  const handleNext = () => {
    if (areFieldsSet || isVerified) {
      setIsLoading(true)
      setTimeout(() => {
        setStep(step + 1)
        setIsLoading(false)
      }, 1000)
    }
  }

  return (
    <FormBackgroundLayout
      title="Create Account"
      subtitle={
        <>
          Have an account?{' '}
          <Link prefetch href="/login" className="text-white">
            Login
          </Link>
        </>
      }
    >
      <TabNavigation currentStep={step} setStep={setStep} />

      <div className="mt-4">
        {step === 1 && (
          <BasicInformation
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            areFieldsSet={areFieldsSet}
            onFieldsSet={setAreFieldsSet}
            onNext={handleNext}
          />
        )}
        {step === 2 && (
          <VerifyEmail
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            areFieldsSet={areFieldsSet}
            isVerified={isVerified}
            onVerify={handleVerify}
            onNext={handleNext}
            onFieldsSet={setAreFieldsSet}
          />
        )}
        {step === 3 && (
          <SetPassword
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            areFieldsSet={areFieldsSet}
            onFieldsSet={setAreFieldsSet}
            onNext={handleNext}
          />
        )}
        {step === 4 && (
          <BusinessDetails
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            areFieldsSet={areFieldsSet}
            onFieldsSet={setAreFieldsSet}
            onNext={handleNext}
          />
        )}
      </div>

      {isLoading && (
        <div className="mt-4">
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
    </FormBackgroundLayout>
  )
}

export default Onboarding
